// divide 10 scale to 5 scale for star UI
export const divideStarRating = rate => {
  return rate ? rate / 2 : null;
};
